import React, { useEffect, useState } from "react";
import "./FormInput.css";

interface FormInputProps {
  title: string;
  subTitle?: string;
  value: string | number;
  onChange: (event: any) => void;
  error: string;
  name: string;
  type: string;
  onBlur: (event: any) => void;
  disabled: boolean;
  isVisible: boolean;
  loading?: boolean;
  onShowVerified?: boolean;
}

const FormInput: React.FC<FormInputProps> = ({
  title,
  subTitle,
  value,
  onChange,
  error,
  name,
  type,
  onBlur,
  disabled,
  isVisible,
  loading,
  onShowVerified,
}) => {
  return isVisible ? (
    <div className="email-form">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className={`form-input-title `}>{title}</div>
        {onShowVerified && (
          <div className="form-input-title-verified">{"Verified"} </div>
        )}
      </div>
      <input
        disabled={disabled}
        onBlur={onBlur}
        type={type}
        name={name}
        placeholder={title}
        value={value}
        onChange={onChange}
        className={`email-input ${onShowVerified ? "verified" : ""} ${
          error ? "error" : ""
        }`}
      />
      {loading && <div className="line-loader"></div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  ) : (
    <></>
  );
};

export default FormInput;
